import { ErrorHandler } from "@angular/core";

export class AppErrorHandler implements ErrorHandler {

  handleError(error: any): void {
    const message = this.extractMessage(error);

    if (this.isChunkLoadError(message)) {
      window.location.replace(window.location.href + "?v=" + Date.now());
      return;
    }

    console.error(error);
  }

  private extractMessage(error: any): string {
    return (
      error?.message ??
      error?.rejection?.message ??
      error?.reason?.message ??
      error?.toString?.() ??
      ""
    );
  }

  private isChunkLoadError(message: string): boolean {
    return (
      message.includes("Failed to fetch dynamically imported module") ||
      message.includes("Importing a module script failed") ||
      message.includes("Failed to load module script") ||
      message.includes("ChunkLoadError") ||
      message.includes("Loading chunk")
    );
  }

}
